export const CLEAR = '@@provider/CLEAR';
export const UPDATE = '@@provider/UPDATE';

export const SET_BLOCK_NUMBER = '@@provider/SET_BLOCK_NUMBER';
export const SET_CHAIN_ID = '@@provider/SET_CHAIN_ID';
